import { ApolloError, useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

interface CountWorkflowEntitiesProps {
  input: API.CountWorkflowEntities;
  skip?: boolean;
  fetchPolicy?: 'cache-and-network' | 'network-only';
}

interface CountWorkflowEntitiesResult {
  totalResults: number;
  loading: boolean;
  refetch: VoidFunction;
  error?: ApolloError;
}

export function useCountWorkflowEntities({
  input,
  skip,
  fetchPolicy = 'cache-and-network',
}: CountWorkflowEntitiesProps): CountWorkflowEntitiesResult {
  const { data, loading, refetch, error } = useQuery<API.CountWorkflowEntitiesQuery>(
    Queries.workflow.countWorkflowEntities,
    {
      variables: { input },
      skip: skip || isNil(input.workflowTemplateId),
      fetchPolicy,
      nextFetchPolicy: 'cache-first',
    },
  );

  return {
    totalResults: data?.countWorkflowEntities?.totalResults ?? 0,
    loading,
    refetch,
    error,
  };
}
